import React from 'react';

const LOGOS = [
  '/assets/images/Company-logo-1-1.png',
  '/assets/images/Company-logo-2-1.png',
  '/assets/images/Company-logo-3-1.png',
  '/assets/images/Company-logo-4-1.png',
  '/assets/images/Company-logo-5-1.png',
  '/assets/images/Company-logo-6.png',
];

// Repeat to ensure seamless scrolling
const extendedLogos = [...LOGOS, ...LOGOS, ...LOGOS, ...LOGOS];

function BrandLogosSlider() {
  return (
    <section className="brand-slider-section">
      <div className="brand-slider-wrapper">
        <div className="brand-marquee-container">
          <div className="brand-marquee-track">
            {extendedLogos.map((logo, idx) => (
              <div className="brand-logo-card" key={idx}>
                <img src={logo} alt={`Brand Logo ${idx + 1}`} className="brand-logo-img" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default BrandLogosSlider;
